import { render, staticRenderFns } from "./list_param.vue?vue&type=template&id=a9fbd4c8&scoped=true"
import script from "./list_param.vue?vue&type=script&lang=js"
export * from "./list_param.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fbd4c8",
  null
  
)

export default component.exports